import { render, staticRenderFns } from "./modal-level-change.vue?vue&type=template&id=6e973aa7&scoped=true"
import script from "./modal-level-change.vue?vue&type=script&lang=js"
export * from "./modal-level-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e973aa7",
  null
  
)

export default component.exports